<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <!------------------------ 步驟一start ---------------------------->
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="d-flex justify-content-between align-items-center w-100">
            <h3 class="modal-title">服務人員個人資訊</h3>
            <button class="btn btn-default" @click="getCustInfo()">
              帶入CRM個人資料
            </button>
          </div>
        </div>
        <div class="modal-body px_37">
          <!-- -------------------主要區塊start ----------------------->
          <section class="editServiceForm search pt_0">
            <label class="editServiceForm__inputItem mb_10">
              <span>保險顧問</span>
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.agnt_name"
                alt="ch"
                maxlength="13"
                placeholder="最多輸入13個中文字"
              />
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>服務單位</span>
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 250px"
                v-model.trim="serviceInfoScope.cevnm"
                maxlength="20"
                placeholder="最多輸入20個中文字"
              />
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>公司電話</span>
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 40px"
                v-model.trim="serviceInfoScope.corp_tel_area"
                maxlength="4"
                v-mfOnlyNumber="{
                  targetObj: serviceInfoScope,
                  targetKey: 'corp_tel_area',
                }"
                @input="serviceInfoScope.corp_tel_area = serviceInfoScope.corp_tel_area.replace(/[^\d]/g, '')"
              />
              <strong>-</strong>
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 102px"
                v-model.trim="serviceInfoScope.corp_tel_Number"
                maxlength="15"
                v-mfOnlyNumber="{
                  targetObj: serviceInfoScope,
                  targetKey: 'corp_tel_Number',
                }"
                @input="serviceInfoScope.corp_tel_Number = serviceInfoScope.corp_tel_Number.replace(/[^\d]/g, '')"
              />
              <strong>#</strong>
              <input
                type="text"
                class="form-control form-control-inline"
                style="width: 68px"
                v-model.trim="serviceInfoScope.crop_tel_Ext"
                maxlength="10"
                v-mfOnlyNumber="{
                  targetObj: serviceInfoScope,
                  targetKey: 'crop_tel_Ext',
                }"
                @input="serviceInfoScope.crop_tel_Ext = serviceInfoScope.crop_tel_Ext.replace(/[^\d]/g, '')"
              />
            </label>
            <label class="editServiceForm__inputItem mb_12">
              <span>行動電話</span>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-inline"
                  style="width: 250px"
                  v-model.trim="serviceInfoScope.mobile"
                  data-vv-name="phone"
                  v-validate="'phone'"
                  :class="{ 'is-invalid': errors.has(`phone`) }"
                  maxlength="10"
                  v-mfOnlyNumber="{
                    targetObj: serviceInfoScope,
                    targetKey: 'mobile',
                  }"
                />
                <span class="waring-text">
                  {{ errors.first(`phone`) ? "行動電話格式有誤" : "" }}
                </span>
              </div>
            </label>
            <label class="editServiceForm__inputItem mb_10">
              <span>MAIL</span>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-inline"
                  style="width: 250px"
                  v-model.trim="serviceInfoScope.email"
                  data-vv-name="email"
                  v-validate="'email'"
                  :class="{ 'is-invalid': errors.has(`email`) }"
                />
                <span class="waring-text">
                  {{ errors.first(`email`) ? "MAIL格式有誤" : "" }}
                </span>
              </div>
            </label>
            <div class="action text-right mt_10">
              <button
                type="submit"
                class="btn btn-default btn-sm py_5"
                @click="$emit('close')"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click="finishEdit()"
              >
                修改
              </button>
            </div>
          </section>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟一end ---------------------------->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getCustInfo, getAgntInfo, updateAgntInfo } from "@/service";

import { Validator } from "vee-validate";
import mf_Mixin from "@/desktop/views/mf/mixin";
import _ from "lodash";
Validator.extend("phone", {
  getMessage: "",
  validate: (value) => {
    let rule = /^09[0-9]{8}$/;
    return rule.test(value);
  },
});
export default {
  name: "EditServicePopup",
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      serviceInfoScope: {},
    };
  },
  computed: {},
  mounted() {},
  methods: {
    //帶入CRM資料
    async getCustInfo() {
      let result = await getCustInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id
      );
      if (result.header && result.header.status === "200") {
        let data = result.body;
        this.serviceInfoScope = _.cloneDeep({
          agnt_name: data.customer.name,
          cevnm: data.customer.corp,
          corp_tel_area: data.customer.corp_tel_area || "",
          corp_tel_Number: data.customer.corp_tel || "",
          crop_tel_Ext: data.customer.corp_tel_ext || "",
          mobile: data.customer.mobile,
          email: data.customer.email,
        });
      }
    },
    async importMV() {
      let result = await this.$mfAPI.MVI0_0100_query({
        agnt_id: this.$store.state.userInfo.id,
      });
      this.serviceInfoScope = _.cloneDeep({
        ...result,
        corp_tel_Number: result.corp_tel.split("#")[0],
        crop_tel_Ext: result.corp_tel.split("#")[1] || "",
      });
    },
    async finishEdit() {
      const checkResult = await this.$validator.validateAll();
      if (checkResult) {
        //呼叫更新API
        let newServiceInfo = {
          agnt_id: this.$store.state.userInfo.id,
          agnt_name: this.serviceInfoScope.agnt_name,
          mobile: this.serviceInfoScope.mobile,
          email: this.serviceInfoScope.email,
          corp_tel_area: this.serviceInfoScope.corp_tel_area || "",
          corp_tel:
            this.serviceInfoScope.crop_tel_Ext !== ""
              ? `${this.serviceInfoScope.corp_tel_Number || ""}#${
                  this.serviceInfoScope.crop_tel_Ext || ""
                }`
              : `${this.serviceInfoScope.corp_tel_Number || ""}`,
          cevnm: this.serviceInfoScope.cevnm,
          upd_source: "MF",
        };
        this.$mfAPI
          .MVI0_0100_update({
            reqList: newServiceInfo,
          })
          .then((res) => {
            this.$emit("update:serviceInfo", newServiceInfo);
            this.$emit("close");
          })
          .catch((error) => {
            this.$emit("close");
            // this.$toast.info({ title: `${error}` });
            this.$toast.info({ title: "執行失敗" });
          });
      }
    },
  },
  directives: {
    mfOnlyNumber: {
      bind: function (el, binding) {
        el.handler = function () {
          if (binding.value.targetObj && binding.value.targetKey) {
            binding.value.targetObj[binding.value.targetKey] = el.value.replace(
              /\D+/,
              ""
            );
          }
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function (el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.importMV();
        this.registerHanlink();
      } else {
        this.$validator.reset();
      }
    },
  },
};
</script>

<style lang="scss">
.editServiceForm {
  display: flex;
  flex-direction: column;
  &__inputItem {
    display: flex;
    align-items: center;
    strong {
      display: inline-block;
      width: 20px;
      text-align: center;
    }
    & > span {
      display: inline-block;
      width: 84px;
      font-weight: 700;
    }
  }
}
</style>
